import script from "./ViewToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewToggle.vue?vue&type=script&setup=true&lang=ts"

import "./ViewToggle.vue?vue&type=style&index=0&id=281287f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281287f7"]])

export default __exports__